import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import { IconDeviceFloppy, IconSquareX } from '@tabler/icons-react';
import { useParams } from 'react-router';
import { validationAccess } from "../../../helpers/validationAccess"
import {
  getModule, setHrefWithSlugHook, getSlug
} from "../../../../src/config/routes/guards/slug";
import { useLocation } from 'react-router';

const EditRiskRegisterComp = (props) => {
  // console.log(props);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [area, setarea] = useState(props?.editRiskRegister?.area);
  const [causeOfTheIncident, setcauseOfTheIncident] = useState(
    props?.editRiskRegister?.causeOfTheIncident
  );
  const [risk, setrisk] = useState(props?.editRiskRegister?.risk);
  const [impact, setimpact] = useState(props?.editRiskRegister?.impact);
  const [existingControl, setexistingControl] = useState(
    props?.editRiskRegister?.existingControl
  );
  const [impactAnalysis, setimpactAnalysis] = useState(
    props?.editRiskRegister?.impactAnalysis
  );
  const [probabilityAnalysis, setprobabilityAnalysis] = useState(
    props?.editRiskRegister?.probabilityAnalysis
  );
  // const [riskEvaluation, setriskEvaluation] = useState(
  //   props?.editRiskRegister?.riskEvaluation
  // );
  const [riskControl, setriskControl] = useState(
    props?.editRiskRegister?.riskControl
  );
  const [riskManagement, setriskManagement] = useState(
    props?.editRiskRegister?.riskManagement
  );
  const [riskFinancing, setriskFinancing] = useState(
    props?.editRiskRegister?.riskFinancing
  );
  const [riskSource, setriskSource] = useState(
    props?.editRiskRegister?.riskSource
  );
  const [categoryCause, setcategoryCause] = useState(
    props?.editRiskRegister?.categoryCause
  );
  // const [impactResidual, setimpactResidual] = useState('');
  // const [probabilityResidual, setprobabilityResidual] = useState('');
  const [targetTime, settargetTime] = useState(
    props?.editRiskRegister?.targetTime
  );

  const [oneLastRiskResidu, setoneLastRiskResidu] = useState([]);
  const [role, setRole] = useState('');

  const routeParams = useParams();
  const location = useLocation();

  const fetchOneLastRiskResidu = async () => {
    try {
      const options = {
        url: `/risk-register/getLastResidu/${routeParams.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setoneLastRiskResidu(data);
      // setimpactResidual(data?.impactResidual);
      // setprobabilityResidual(data?.probabilityResidual);
    } catch (err) {
      setLoading(false);
      console.log(err.message);
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook('/login');
        }, 3000);
      } else {
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook('/login');
          }, 3000);
        }
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchLoginStatus();
    fetchOneUser();
    fetchOneLastRiskResidu();
  }, []);

  const handleEditRiskRegister = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      idActivityTarget: routeParams.id,
      area: area,
      causeOfTheIncident: causeOfTheIncident,
      risk: risk,
      impact: impact,
      existingControl: existingControl,
      impactAnalysis: impactAnalysis,
      probabilityAnalysis: probabilityAnalysis,
      // riskEvaluation: riskEvaluation,
      riskControl: riskControl,
      riskManagement: riskManagement,
      riskFinancing: riskFinancing,
      riskSource: riskSource,
      categoryCause: categoryCause,
      targetTime: targetTime,
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: `/risk-register/update/${props?.editRiskRegister?.id}`,
      method: 'PATCH',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully ubah laporan!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  return (
    <>
      <div>
        <div className="row">
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="area" className="form-label required">
                Area/Lokasi
              </label>
              <textarea
                className="form-control row-cols-3"
                id="area"
                onChange={(e) => setarea(e.target.value)}
                value={area}
              ></textarea>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-5">
              <label
                htmlFor="causeOfTheIncident"
                className="form-label required"
              >
                Sebab
              </label>
              <textarea
                className="form-control row-cols-3"
                id="causeOfTheIncident"
                onChange={(e) => setcauseOfTheIncident(e.target.value)}
                value={causeOfTheIncident}
              ></textarea>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="risk" className="form-label required">
                Risiko
              </label>
              <textarea
                type="text"
                className="form-control row-cols-3"
                id="risk"
                autoComplete="off"
                onChange={(e) => setrisk(e.target.value)}
                value={risk}
              ></textarea>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="impact" className="form-label required">
                Dampak Risiko
              </label>
              <textarea
                type="text"
                className="form-control row-cols-3"
                id="impact"
                autoComplete="off"
                onChange={(e) => setimpact(e.target.value)}
                value={impact}
              ></textarea>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="existingControl" className="form-label required">
                Pengendalian Yang Sudah Ada
              </label>
              <textarea
                type="text"
                className="form-control row-cols-3"
                id="existingControl"
                autoComplete="off"
                onChange={(e) => setexistingControl(e.target.value)}
                value={existingControl}
              ></textarea>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="riskManagement" className="form-label required">
                Uraian Penanganan
              </label>
              <textarea
                className="form-control row-cols-3"
                id="riskManagement"
                onChange={(e) => setriskManagement(e.target.value)}
                value={riskManagement}
              ></textarea>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-4">
            <div className="mb-5">
              <label
                htmlFor="probabilityAnalysis"
                className="form-label required"
              >
                Probabilitas
              </label>
              <select
                className="form-select"
                id="probabilityAnalysis"
                value={probabilityAnalysis}
                onChange={(e) => setprobabilityAnalysis(e.target.value)}
              >
                <option selected disabled>
                  Pilih
                </option>
                <option value={'1'}>Jarang</option>
                <option value={'2'}>Kemungkinan Kecil</option>
                <option value={'3'}>Kemungkinan Sedang</option>
                <option value={'4'}>Kemungkinan Besar</option>
                <option value={'5'}>Hampir Pasti Terjadi</option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="impactAnalysis" className="form-label required">
                Dampak
              </label>
              <select
                className="form-select"
                id="impactAnalysis"
                value={impactAnalysis}
                onChange={(e) => setimpactAnalysis(e.target.value)}
              >
                <option selected disabled>
                  Pilih
                </option>
                <option value={'1'}>Tidak Signifikan</option>
                <option value={'2'}>Kecil</option>
                <option value={'3'}>Sedang</option>
                <option value={'4'}>Besar</option>
                <option value={'5'}>Katastropik</option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="riskControl" className="form-label required">
                Opsi Pengendalian
              </label>
              <select
                className="form-select"
                id="riskControl"
                value={riskControl}
                onChange={(e) => setriskControl(e.target.value)}
              >
                <option selected disabled>
                  Pilih
                </option>
                <option value={1}>Preventive (Pencegahan)</option>
                <option value={2}>Reduction (Reduksi)</option>
                <option value={3}>Accept (Terima)</option>
                <option value={4}>Contigency (Alternatif)</option>
                <option value={5}>Transfer (Pengalihan)</option>
              </select>
            </div>
          </div>
          {/* <div className="col-4">
            <div className="mb-5">
              <label htmlFor="riskEvaluation" className="form-label required">
                Penanganan Risiko
              </label>
              <select
                className="form-select"
                id="riskEvaluation"
                value={riskEvaluation}
                onChange={(e) => setriskEvaluation(e.target.value)}
              >
                <option selected disabled>
                  Pilih
                </option>
                <option value={'Yes'}>Ya</option>
                <option value={'No'}>Tidak</option>
              </select>
            </div>
          </div> */}
        </div>

        <div className="row">
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="riskSource" className="form-label required">
                Sumber Risiko
              </label>
              <select
                className="form-select"
                id="riskSource"
                value={riskSource}
                onChange={(e) => setriskSource(e.target.value)}
              >
                <option selected disabled>
                  Pilih
                </option>
                <option value={'Eksternal'}>Eksternal</option>
                <option value={'Internal'}>Internal</option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="categoryCause" className="form-label required">
                Kategori Penyebab
              </label>
              <select
                className="form-select"
                id="categoryCause"
                value={categoryCause}
                onChange={(e) => setcategoryCause(e.target.value)}
              >
                <option selected disabled>
                  Pilih
                </option>
                <option value={'C'}>Controllable (C)</option>
                <option value={'UC'}>Uncontrollable (UC)</option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="riskFinancing" className="form-label required">
                Pembiayaan Risiko
              </label>
              <select
                className="form-select"
                id="riskFinancing"
                value={riskFinancing}
                onChange={(e) => setriskFinancing(e.target.value)}
              >
                <option selected disabled>
                  Pilih
                </option>
                <option value={'Retensi Risiko'}>Retensi Risiko</option>
                <option value={'Transfer Risiko'}>Transfer Risiko</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="targetTime" className="form-label required">
                Target Waktu
              </label>
              <input
                type="date"
                className="form-control row-cols-3"
                id="targetTime"
                autoComplete="off"
                onChange={(e) => settargetTime(e.target.value)}
                value={targetTime}
              ></input>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="probabilityResidual" className="form-label ">
                Probabilitas Residual
              </label>
              <input
                type="text"
                className="form-control row-cols-3"
                id="probabilityResidual"
                autoComplete="off"
                // onChange={(e) => setprobabilityResidual(e.target.value)}
                value={oneLastRiskResidu?.probabilityResidual}
                disabled
              ></input>
              <small className="text-info">
                Probabilitas Residu akan terlihat jika telah diisikan hasil
                pemantauan
              </small>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-5">
              <label htmlFor="impactResidual" className="form-label ">
                Dampak Residual
              </label>
              <input
                type="text"
                className="form-control row-cols-3"
                id="impactResidual"
                autoComplete="off"
                // onChange={(e) => setimpactResidual(e.target.value)}
                value={oneLastRiskResidu?.impactResidual}
                disabled
              ></input>
              <small className="text-info">
                Dampak Residu akan terlihat jika telah diisikan hasil pemantauan
              </small>
            </div>
          </div>
        </div>

        <div className="mt-5 row">
          <div className="d-flex flex-center flex-row-fluid pt-2">
            <Button
              disabled={disabled}
              variant="primary"
              size="sm"
              onClick={() => handleEditRiskRegister()}
            >
              <IconDeviceFloppy stroke={2} />{' '}
              {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
            </Button>
            &nbsp;
            <Button variant="danger" size="sm" onClick={() => props.close()}>
              <IconSquareX stroke={2} /> Tutup
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditRiskRegisterComp;
